import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { getBaseUrl } from '../main';
import { MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalInterceptorConfiguration, MsalService, MsalGuard, MsalInterceptor, MsalBroadcastService, MsalModule } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { environment } from './environments/environment';
import { AuthInterceptor } from './interceptors/auth.interceptor';

export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication({
		auth: {
			clientId: environment.msalConfig.clientId,
			authority: environment.msalConfig.authority,
			redirectUri: environment.msalConfig.redirectUri,
			navigateToLoginRequestUrl: true
		},
		cache: {
			cacheLocation: BrowserCacheLocation.LocalStorage,
			storeAuthStateInCookie: false,
		},
		system: {
			allowPlatformBroker: false,
			loggerOptions: {
				logLevel: LogLevel.Info,
				piiLoggingEnabled: false,
			},
		},
	});
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
	return {
		interactionType: InteractionType.Redirect,
		authRequest: {
			scopes: [environment.azureClient],
		},
	};
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
	const protectedResourceMap = new Map<string, Array<string>>();
	
	protectedResourceMap.set(environment.api, [environment.azureClient]);
	protectedResourceMap.set(environment.msalConfig.authority, [environment.azureClient]);

	return {
		interactionType: InteractionType.Redirect,
		protectedResourceMap,
	};
}

export const appConfig: ApplicationConfig = {
	providers: [
		importProvidersFrom(
			BrowserModule,
			HttpClientModule,
			FormsModule,
			ReactiveFormsModule,
			MsalModule
		),
		provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
		{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory,
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: MSALGuardConfigFactory,
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: MSALInterceptorConfigFactory,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		MsalService,
		MsalGuard,
		MsalInterceptor,
		MsalBroadcastService,
	],
};
